// @flow
import $ from "../vendor/jquery";

// Global grobot objects
import global, {menu_translate, clear_old_page} from "./Global";
import {activateMenuItem, jsonAjax} from "../util";

import Settings from "./Settings";
import Graph from "./Graph";
import Wagons from "./Wagons";
import AppConfig from "../config";
import Legacy from "../Legacy";

/**
 * Laadimisel oleva vaguni info kuvamise moodul
 */
class LoadingGraph {
    /**
     * @type {?LoadingGraph}
     */
    static loadingGraphInstance = null;

    /**
     * @returns {LoadingGraph}
     */
    static getInstance() {
        if (LoadingGraph.loadingGraphInstance == null) LoadingGraph.loadingGraphInstance = new LoadingGraph();
        return LoadingGraph.loadingGraphInstance;
    }

    constructor() {
        this.loadingwagon_urlbase = AppConfig.BASE_URL + "/loading";
    }

    make_loading_graph_page() {
        // if (current_shown_wagon == loading_wagon) return;
        let graph = Graph.getInstance();
        let settings = Settings.getInstance();
        menu_translate();
        clear_old_page();

        global.current_shown_wagon = global.loading_wagon;
        graph.nominalButtonOn = settings.getNominalGraph();
        graph.show_analyze(global.current_shown_wagon);
        activateMenuItem("graph");
    }

    // Laadimisel oleva vaguni info sisselaadimise käivitamine
    load_loadingwagon() {
        if (!global.do_loading_wagon)
            return;
        let wurl = this.loadingwagon_urlbase;
        Legacy.debug("loading " + wurl);
        jsonAjax({
            type : "GET",
            url : wurl,
            success: function (data) {
                this.loadingwagoncall(data);
            }.bind(this)
        });
    }

    loadingwagoncall(data) {
        Legacy.debug("loadingwagoncall");
        let wagons = Wagons.getInstance();
        let graph = Graph.getInstance();

        if (data) {
            global.loading_wagon = data['loadingResult'];
            if (global.loading_wagon == null) global.loading_wagon = 0;
            if (global.current_shown_wagon != global.loading_wagon) {
                wagons.load_wagon(global.loading_wagon);
                global.current_shown_wagon = global.loading_wagon;

                this.make_loading_graph_page();
            } else {
                // Kui #graph0 ei eksisteeri, siis järelikult on vaja leht alles
                // teha, vastasel korral teeme graafikutele refresh
                if ($('#graph0').length == 0)
                    this.make_loading_graph_page();
                else
                    graph.refreshGraphs();
            }
        }
    }

}

export default LoadingGraph;
